import { render, staticRenderFns } from "./speaker-detail.vue?vue&type=template&id=253ebb7f&scoped=true"
import script from "./speaker-detail.vue?vue&type=script&lang=js"
export * from "./speaker-detail.vue?vue&type=script&lang=js"
import style0 from "./speaker-detail.vue?vue&type=style&index=0&id=253ebb7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ebb7f",
  null
  
)

export default component.exports